import { Language } from "@/interfaces/i18n";
import flagEn from "@/assets/flags/flagGB.png";
import flagRu from "@/assets/flags/flagRU.png";

export const supportedLanguages: Language[] = [
  { common: "English", code: "en", icon: flagEn },
  { common: "Русский", code: "ru", icon: flagRu },
];
